import { useEffect, useState } from "react";
import { BsCartFill } from "react-icons/bs";
import { TbTruckReturn } from "react-icons/tb";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export default function Sidebar() {
    const { i18n } = useSelector(state => state.someFun);
    const [translate, setTranslate] = useState(true);

    useEffect(() => {
        if (i18n === 'en') {
            setTranslate(true)
        }
        else {
            setTranslate(false)
        }
    }, [i18n]);

    return (
        <div className="">
            <aside className="" aria-label="Sidebar">
                <div className="rounded-xl md:h-screen overflow-y-auto py-4 px-3 bg-gray-50 ">
                    <ul className="space-y-2">
                        <li>
                            <Link to="/knowledge" className="hover:no-underline hover:text-gray-800 flex items-center p-2 text-base font-normal text-gray-900 rounded-lg hover:bg-gray-100 ">
                                <BsCartFill className="w-6 h-6 text-gray-500 transition duration-75  group-hover:text-gray-900 " />
                                <span className="ml-3">{translate ? 'How to Buy' : 'কিভাবে ক্রয় করবো'} </span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/knowledge/returns-and-refunds" className="hover:no-underline hover:text-gray-800 flex items-center p-2 text-base font-normal text-gray-900 rounded-lg hover:bg-gray-100 ">
                                <TbTruckReturn className="w-6 h-6 text-gray-500 transition duration-75  group-hover:text-gray-900 " />
                                <span className="flex-1 ml-3 whitespace-nowrap">{translate ? 'Returns & Refunds' : 'রিটার্ন ও রিফান্ড পলিসি'} </span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/knowledge/terms-and-conditions" className="hover:no-underline hover:text-gray-800 flex items-center p-2 text-base font-normal text-gray-900 rounded-lg hover:bg-gray-100 ">
                                <svg aria-hidden="true" className="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75  group-hover:text-gray-900 " fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l2-2a1 1 0 00-1.414-1.414L11 7.586V3a1 1 0 10-2 0v4.586l-.293-.293z"></path><path d="M3 5a2 2 0 012-2h1a1 1 0 010 2H5v7h2l1 2h4l1-2h2V5h-1a1 1 0 110-2h1a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5z"></path></svg>
                                <span className="flex-1 ml-3 whitespace-nowrap">{translate ? 'Terms & Conditions' : 'শর্তাবলী'}</span>
                            </Link>
                        </li>

                    </ul>
                </div>
            </aside>
        </div>
    );
}